(function(){
  var box=document.getElementById('box'), stage=document.getElementById('stage');
  if(!box) return;
  var rx=-22, ry=-30, vx=0, vy=0, drag=false, lx=0, ly=0, idle=true, last=performance.now();
  function render(){ box.style.transform='translateZ(-120px) rotateX('+rx+'deg) rotateY('+ry+'deg)'; }
  render();
  stage.addEventListener('pointerdown',function(e){ drag=true; idle=false; lx=e.clientX; ly=e.clientY; vx=0; vy=0; try{stage.setPointerCapture(e.pointerId);}catch(err){} });
  window.addEventListener('pointermove',function(e){ if(!drag)return; var dx=e.clientX-lx,dy=e.clientY-ly; lx=e.clientX; ly=e.clientY; ry+=dx*0.5; rx-=dy*0.5; if(rx>88)rx=88; if(rx<-88)rx=-88; vx=dx*0.5; vy=-dy*0.5; render(); });
  window.addEventListener('pointerup',function(){ drag=false; });
  function loop(now){ var dt=now-last; last=now;
    if(!drag){ if(Math.abs(vx)>0.02||Math.abs(vy)>0.02){ ry+=vx; rx+=vy; if(rx>88)rx=88; if(rx<-88)rx=-88; vx*=0.94; vy*=0.94; render(); }
      else if(idle){ ry+=dt*0.008; render(); } }
    requestAnimationFrame(loop);
  }
  requestAnimationFrame(loop);
  var bs=document.querySelectorAll('#ctrls button');
  for(var i=0;i<bs.length;i++) bs[i].addEventListener('click',function(){
    idle=false; vx=0; vy=0;
    for(var j=0;j<bs.length;j++) bs[j].classList.remove('on'); this.classList.add('on');
    var tx=parseFloat(this.getAttribute('data-x')), ty=parseFloat(this.getAttribute('data-y'));
    var t0=performance.now(),sx=rx,sy=ry,d=650;
    (function an(t){ var k=(t-t0)/d; if(k>1)k=1; var e=1-Math.pow(1-k,3); rx=sx+(tx-sx)*e; ry=sy+(ty-sy)*e; render(); if(k<1)requestAnimationFrame(an); })(t0);
  });
})();
